import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { ReactComponent as SuccessIcon } from "../../../assets/images/snow-chat/chat-success.svg";
import { sendChatForm } from "../../../utils/TagManagerHelper";

function ChatSuccess({ isContactSupport, isMyCssContactSupport }) {
  useEffect(() => {
    if (!isMyCssContactSupport) {
      sendChatForm();
    }
  }, []);

  return (
    <div className="chat-success">
      <SuccessIcon />
      <h6 className="title-text medium-contrast">
        Your {isContactSupport || isMyCssContactSupport ? "support request " : "message "}
        <br />
        has been sent
      </h6>
      {/* {isContactSupport ? (
        <p className="mb-3 medium-contrast">
          We will take charge of it and get in touch
          <br />
          with you as soon as possible
        </p>
      ) : (
        <p className="mb-3">
          We will review your message and answer you
          <br />
          as soon as possible.
        </p>
      )} */}
      {isContactSupport && (
        <p className="mb-3 medium-contrast">
          We will take charge of it and get in touch
          <br />
          with you as soon as possible
        </p>
      )}
      {isMyCssContactSupport && (
        <p className="mb-3 medium-contrast">
          The Reply Quality Team will take it in
          <br />
          charge and get in touch with you as
          <br />
          as soon as possible
        </p>
      )}
      {!isContactSupport && !isMyCssContactSupport && (
        <p className="mb-3">
          We will review your message and answer you
          <br />
          as soon as possible.
        </p>
      )}

      <p className="sub">
        {isContactSupport && !isMyCssContactSupport
          ? "Track your ticket in"
          : "Monitor the thread in"}
        <br />
        {(isMyCssContactSupport || isContactSupport) && (
          <a tabIndex={0} className="text-underline p1" href="/support/requests">
            <b>My support requests</b>
          </a>
        )}
        {/* {isMyCssContactSupport && (
          <a tabIndex={0}  className="text-underline p1" href="/support/requests/mycss">
            <b>My support requests</b>
          </a>
        )} */}
        {!isContactSupport && !isMyCssContactSupport && (
          <a tabIndex={0} className="text-underline p1" href="/my-rose-messages">
            <b>My messages</b>
          </a>
        )}
        {/* {isContactSupport ? (
          <a tabIndex={0}  className="text-underline p1" href="/support/requests">
            <b>My support requests</b>
          </a>
        ) : (
          <a tabIndex={0}  className="text-underline p1" href="/my-rose-messages">
            <b>My messages</b>
          </a>
        )} */}
        &nbsp;area.
      </p>
    </div>
  );
}

ChatSuccess.propTypes = {
  isContactSupport: PropTypes.bool,
  isMyCssContactSupport: PropTypes.bool,
};

ChatSuccess.defaultProps = {
  isContactSupport: false,
  isMyCssContactSupport: false,
};

export default ChatSuccess;
